export default "__VITE_ASSET__00eeea9b__"